import CanvasBase from "./CanvasBase";
import React from "react";
import PitchCanvas from "./PitchCanvas";

const simpleheat = require('./simpleheat');

class PlayerPositionsHeatMap extends PitchCanvas {

    constructor(props) {
        super(props);
        this.handlePithLoaded = this.handlePithLoaded.bind(this);
        this.handleCanvasBackgroundLoaded = this.handleCanvasBackgroundLoaded.bind(this);
    }

    /**
     * Renders the canvas component.
     * @returns {React.ReactNode}
     */
    render = () => {
        const {resolution} = this.canvasConfig();
        const {width, height} = resolution;

        return (
            <div className="canvas-container position-relative">
                <canvas className="position-absolute" ref="canvas" width={width} height={height} style={this.canvasStyle()}/>
                <canvas className="position-absolute" ref="heatmap" width={width} height={height} style={this.canvasStyle()}/>
            </div>
        );
    };
    getHeatMapRef = () => this.refs.heatmap;

    componentWillReceiveProps(nextProps, nextContext) {
        const {positionCode} = nextProps;
        const {resolution} = this.canvasConfig();

        let {heat} = this;
        const canvas = this.getHeatMapRef();
        heat = simpleheat(canvas);
        heat.radius(25, 100);

        heat.gradient({
            '0.33': '#71B78Aff',
            '0.66': '#F5E33Dff',
            '0.99': '#EF2323',
        });

        heat.addV = ([x, y, c]) => Array.from(Array(c)).map(i => heat.add([x, y, 1]));
        window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;

        let frame;
        const draw = () => {
            heat.draw();
            frame = null;
        };

        let leftButtonDown = false;
        canvas.onmousedown = function (e) {
            // Left mouse button was pressed, set flag
            if (e.which === 1) leftButtonDown = true;
        };
        canvas.onmouseup = function (e) {
            // Left mouse button was released, clear flag
            if (e.which === 1) leftButtonDown = false;
        };

        canvas.onmousemove = function (e) {
            if (leftButtonDown) {
                heat.add([e.layerX * resolution.width / canvas.clientWidth, e.layerY * resolution.height / canvas.clientHeight, 1]);

                frame = frame || window.requestAnimationFrame(draw);
            }
        };

        if (heat && positionCode) {
            // const point = PitchCanvas.position(positionCode, resolution.width / 2, resolution.height / 2);
            const points = PitchCanvas.tempPosition(positionCode, resolution.width / 2, resolution.height / 2);
            heat.data(points);
            heat.draw();

            // heat.addV([this.offsetX(point.x), this.offsetY(point.y), 20]);
        }
    }

    /**
     * @override
     * @param x {float} The x-coordinate.
     * @returns {float} The x-coordinate after apply offset.
     */
    offsetX = (x) => {
        const {resolution} = this.canvasConfig();
        const {width} = resolution;

        return x + width / 2
    };

    /**
     * @override
     * @param y {float} The y-coordinate.
     * @returns {float} The y-coordinate after apply offset.
     */
    offsetY = (y) => {
        const {resolution} = this.canvasConfig();
        const {height} = resolution;

        return -y + height / 2
    };


    baseConfig = () => ({
            width: '100%',
            resolution: {width: 1000, height: 1335},
        }
    );
}


export default PlayerPositionsHeatMap;
